import React from "react";

import { ReportChartComponents } from "constants/report.constant";

export default function ReportWidgetModel({ report, data, setData, intialLayout, setError, error, isLoading, width, startTime, endTime }) {
  return (
    <>
      {report.Type &&
        React.createElement(ReportChartComponents[report.Type], {
          report,
          data,
          setData,
          intialLayout,
          setError,
          error,
          isLoading,
          width,
          startTime,
          endTime
        })}
    </>
  );
}
